"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.number.constructor");
var _redbook = _interopRequireDefault(require("@/api/activity/redbook.js"));
var _nprogress = require("nprogress");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'couponEAct',
  components: {},
  props: {
    userId: {
      type: Number,
      default: 0
    }
  },
  watch: {
    userId: {
      immediate: true,
      handler: function handler(newId, oldId) {
        // 避免初始化时的不必要调用
        if (newId === oldId && oldId !== undefined) return;
        console.log('userId', newId);
        if (newId) {
          this.searchForm.officerId = newId;
          this.getOfficers();
        }
      }
    }
  },
  emits: ['addAct', 'handleEdit', 'detailUser'],
  data: function data() {
    return {
      resPath: process.env.VUE_APP_IMAGE_PATH,
      loading: false,
      officers: [],
      searchForm: {
        month: '',
        status: '',
        officerId: '',
        page: 1,
        limit: 10,
        total: 0
      },
      tableData: [],
      // ...新增二维码相关状态...
      qrDialogVisible: false,
      qrImage: '',
      qrObj: {},
      // 奖励记录弹窗相关
      rewardDialogVisible: false,
      rewardList: [],
      rewardLoading: false,
      rewardSearch: {
        page: 1,
        limit: 10,
        total: 0
      },
      currentOfficerId: null
    };
  },
  computed: {},
  methods: {
    changeTime: function changeTime(e) {
      console.log(e);
      if (!e || e == '') {
        this.searchForm.month = '';
        this.fetchList(); // 重新加载数据
      } else {
        this.searchForm.month = e;
      }
    },
    indexMethod: function indexMethod(index) {
      return (this.searchForm.page - 1) * this.searchForm.limit + index + 1;
    },
    pad: function pad(n) {
      return n.toString().padStart(2, '0');
    },
    fetchList: function fetchList() {
      var _this = this;
      this.loading = true;
      _redbook.default.officerLog(this.searchForm).then(function (res) {
        res.records.forEach(function (item) {
          var date = new Date(item.begDate);
          var date2 = new Date(item.endDate);
          var year = date.getFullYear();
          var month = _this.pad(date.getMonth() + 1);
          var day = _this.pad(date.getDate());
          var hours = _this.pad(date.getHours());
          var mins = _this.pad(date.getMinutes());
          var secs = _this.pad(date.getSeconds());
          item.begDate = "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(mins, ":").concat(secs);
          var year2 = date2.getFullYear();
          var month2 = _this.pad(date2.getMonth() + 1);
          var day2 = _this.pad(date2.getDate());
          var hours2 = _this.pad(date2.getHours());
          var mins2 = _this.pad(date2.getMinutes());
          var secs2 = _this.pad(date2.getSeconds());
          item.endDate = "".concat(year2, "-").concat(month2, "-").concat(day2, " ").concat(hours2, ":").concat(mins2, ":").concat(secs2);
        });
        _this.tableData = res.records || [];
        _this.searchForm.total = res.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    openRewardDialog: function openRewardDialog(row) {
      // 尝试从行数据或搜索表单中找到 officerId，回退到 row.id
      this.currentOfficerId = row.officerId || this.searchForm.officerId || row.id;
      this.rewardSearch.page = 1;
      this.rewardDialogVisible = true;
      this.fetchRewardList();
    },
    fetchRewardList: function fetchRewardList() {
      var _this2 = this;
      if (!this.currentOfficerId) return;
      this.rewardLoading = true;
      var params = {
        page: this.rewardSearch.page,
        limit: this.rewardSearch.limit,
        officerId: this.currentOfficerId
      };
      _redbook.default.officerRewardLog(params).then(function (res) {
        var records = res.records || [];
        records.forEach(function (item) {
          if (item.createDate) {
            try {
              var date = new Date(item.createDate);
              var y = date.getFullYear();
              var m = _this2.pad(date.getMonth() + 1);
              var d = _this2.pad(date.getDate());
              var hh = _this2.pad(date.getHours());
              var mm = _this2.pad(date.getMinutes());
              var ss = _this2.pad(date.getSeconds());
              item.createTime = "".concat(y, "-").concat(m, "-").concat(d, " ").concat(hh, ":").concat(mm, ":").concat(ss);
            } catch (e) {}
          }
        });
        _this2.rewardList = records;
        _this2.rewardSearch.total = res.total || 0;
      }).finally(function () {
        _this2.rewardLoading = false;
      });
    },
    handleRewardSizeChange: function handleRewardSizeChange(newSize) {
      this.rewardSearch.limit = newSize;
      this.rewardSearch.page = 1;
      this.fetchRewardList();
    },
    handleRewardPageChange: function handleRewardPageChange(newPage) {
      this.rewardSearch.page = newPage;
      this.fetchRewardList();
    },
    download: function download() {},
    // 每页条数变化
    handleSizeChange: function handleSizeChange(newSize) {
      this.searchForm.limit = newSize;
      this.searchForm.page = 1;
      this.fetchList();
    },
    // 页码变化
    handlePageChange: function handlePageChange(newPage) {
      this.searchForm.page = newPage;
      this.fetchList();
    },
    getOfficers: function getOfficers() {
      var _this3 = this;
      var data = {
        page: 1,
        limit: 99999
      };
      _redbook.default.getofficer(data).then(function (res) {
        _this3.officers = res.records || [];
        if (res.records[0] && (_this3.userId == 'null' || _this3.userId == 0)) {
          _this3.searchForm.officerId = res.records[0].id;
          _this3.fetchList();
        } else {
          _this3.fetchList();
        }
      });
    }
  },
  mounted: function mounted() {
    this.fetchList();
    this.getOfficers();
  }
};